import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { heroContent } from '../data/mock';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen bg-black flex items-center overflow-hidden">
      {/* Grid Pattern Overlay */}
      <div 
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage: `
            repeating-linear-gradient(0deg, transparent, transparent 1px, transparent 1px, transparent 60px),
            repeating-linear-gradient(-90deg, rgba(255,255,255,0.1), rgba(255,255,255,0.1) 1px, transparent 1px, transparent 60px)
          `,
          backgroundSize: '60px 60px'
        }}
      />

      {/* Gradient Orbs - Decorative only */}
      <div className="absolute top-1/4 right-1/4 w-[500px] h-[500px] bg-[#00FFD1]/5 rounded-full blur-[150px] pointer-events-none" />
      <div className="absolute bottom-1/4 left-1/4 w-[400px] h-[400px] bg-[#6B5BFF]/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-5 md:px-[7.6923%] pt-32 pb-20">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 text-white/70 text-sm">
              <span className="w-2 h-2 bg-[#00FFD1] rounded-full animate-pulse" />
              Next-Gen AI Content Platform
            </div>

            {/* Headline */}
            <h1 className="text-4xl md:text-5xl lg:text-[66px] font-semibold leading-[1.1] tracking-[-0.62px] text-white">
              {heroContent.headline}
            </h1>

            {/* Subheadline */}
            <p className="text-2xl md:text-3xl font-medium text-[#00FFD1]">
              {heroContent.subheadline}
            </p>

            {/* Supporting Text */}
            <p className="text-lg md:text-xl text-white/70 leading-relaxed max-w-xl">
              {heroContent.supportingText}
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button 
                onClick={() => navigate('/contact')}
                className="group bg-[#00FFD1] text-black px-8 py-4 text-lg font-medium hover:bg-[#00FFD1]/10 hover:text-[#00FFD1] transition-all duration-400 flex items-center justify-center gap-3"
              >
                Get Started
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
              <button 
                onClick={() => navigate('/contact')}
                className="group bg-white/10 text-white px-8 py-4 text-lg font-medium hover:bg-white hover:text-black transition-all duration-400 flex items-center justify-center gap-3"
              >
                Request Demo
              </button>
            </div>
          </div>

          {/* Right Content - Logo Animation */}
          <div className="hidden lg:flex items-center justify-center">
            <div className="relative">
              {/* Glow Effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-[#00FFD1]/20 via-[#6B5BFF]/20 to-[#FF6B6B]/20 blur-[80px] rounded-full" />
              <img
                src="https://customer-assets.emergentagent.com/job_94f5a94a-682d-481e-b75c-a692290dbeab/artifacts/ksy0u9nl_Logo.png"
                alt="Prysh AI Labs"
                className="relative w-[500px] h-auto object-contain animate-float"
              />
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/40">
          <span className="text-sm">Scroll to explore</span>
          <div className="w-6 h-10 border-2 border-white/20 rounded-full flex justify-center pt-2">
            <div className="w-1.5 h-3 bg-[#00FFD1] rounded-full animate-scroll" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
